export const workingTimeColor = '#BF295C';
export const holidayColor = '#23A26D';
export const dayOffColor = '#1F6AD4';
